import { render } from "./GroupSection.vue?vue&type=template&id=2d65e062&scoped=true"
import script from "./GroupSection.vue?vue&type=script&lang=js"
export * from "./GroupSection.vue?vue&type=script&lang=js"

import "./GroupSection.vue?vue&type=style&index=0&id=2d65e062&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d65e062"]])

export default __exports__